//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SelectFaceList.js";
import "../no/SelectFace.js";
import "../no/SelectBody.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AutoCentroid",1,0],[0,"ConstantThickness",1,0],[1,"DieRadius",0,"Expression",0],[0,"FromCsys",1,"CoordinateSystem",0],[0,"HideTool",1,0],[0,"IncludeRounding",1,0],[0,"InferThickness",1,0],[1,"PierceFaces",0,"SelectFaceList",0],[1,"PunchRadius",0,"Expression",0],[1,"TargetFace",0,"SelectFace",0],[1,"Thickness",0,"Expression",0],[0,"ToCsys",1,"CoordinateSystem",0],[1,"ToolBody",0,"SelectBody",0],[0,"Type",1,0]],[],[]];
SPLM.Features.SheetMetal.SolidPunchBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.SolidPunchBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.SolidPunchBuilder.Types = Object.freeze({
    "PunchType" : "PunchType", "DieType" : "DieType"});

export default SPLM;